import createIcon from '../../createIcon';

/**
 * @component @name ArrowUpward
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxMkw1LjQxIDEzLjQxTDExIDcuODNWMjBIMTNWNy44M0wxOC41OCAxMy40MkwyMCAxMkwxMiA0TDQgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowUpward = createIcon('ArrowUpward', [
  [
    'path',
    { d: 'M4 12L5.41 13.41L11 7.83V20H13V7.83L18.58 13.42L20 12L12 4L4 12Z', key: '1ftyf6' },
  ],
]);

export default ArrowUpward;
